module.exports = __webpack_public_path__ + "static/media/whatsApp.9ee0a270.svg";